import { X } from "lucide-react";
import {Button} from "../ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";

const emojis = ["😞", "🙁", "😐", "🙂", "😄"];

export function FeedbackPopup({ onClose, onSubmit }) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <Card className="w-96 bg-white">
        <CardHeader className="flex flex-row items-center justify-between">
          <CardTitle>How was your experience?</CardTitle>
          <Button variant="ghost" size="icon" onClick={onClose}>
            <X className="h-4 w-4" />
          </Button>
        </CardHeader>
        <CardContent>
          <div className="flex justify-between mb-4">
            {emojis.map((emoji, index) => (
              <button
                key={index}
                onClick={() => onSubmit(index + 1)}
                className="text-4xl transition-transform hover:scale-110 focus:outline-none focus:ring-2 focus:ring-blue-500 rounded-full p-2"
              >
                {emoji}
              </button>
            ))}
          </div>
          <p className="text-center text-sm text-muted-foreground">
            Your feedback helps us improve our service
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
